import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAb95C-WuP_wJRaQMb6ruPhhTTmLM25O8g",
  authDomain: "kindred-agentic-auto-coupons.firebaseapp.com",
  projectId: "kindred-agentic-auto-coupons",
  storageBucket: "kindred-agentic-auto-coupons.firebasestorage.app",
  messagingSenderId: "993332135262",
  appId: "1:993332135262:web:c4365c1c7629595910bbcf",
  measurementId: "G-7Y2JE5XXDK",
};

export const app = initializeApp(firebaseConfig);
